module.exports = __webpack_public_path__ + "assets/img/rim-pacific.5c0872bd.png";